function formatPhoneNumber(phoneNumber) {
  const pn = phoneNumber.toString().replace(/\D/g, '');
  return `(${pn.slice(0, 3)}) ${pn.slice(3, 6)}-${pn.slice(6, 10)}`;
}

export default formatPhoneNumber;
